<template>
  <a-row>
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1 faq-content">
      <a-tabs
        :key="$route.fullPath"
        v-model="tabPane"
        class="main-tabs"
        type="card"
        @change="tabPaneChangeHandler"
      >
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>

          <!-- lang tabs -->
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
                <a-button
                  v-if="langTab == 'uz' || langTab == 'oz'"
                  @click.stop="translitAction"
                >
                  Перевести копию на
                  {{ langTab == "uz" ? "кирилицу" : "латиницу" }}
                </a-button>
              </a-row>
            </a-col>
          </a-row>

          <!-- position -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Позиция:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model.number="form.position"
                placeholder="Введите позицию"
              />
              <div v-if="!form.position" class="error-text">
                Введите позицию.
              </div>
            </a-col>
          </a-row>

          <!-- question -->
          <a-row align="middle" class="flex-baseline mb-2">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Вопрос:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <editor
                :key="'tinymce_' + tabPane"
                v-model="form.question[langTab]"
                :init="{
                  height: 300,
                  plugins: [
                    'advlist preview autolink lists link image imagetools charmap print preview',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                  ],
                  toolbar:
                    'undo redo | preview | formatselect | bold italic underline forecolor | \
                  image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat',
                  language: 'ru',
                  language_url: '/js/tinymce/langs/ru.js',
                  menubar: false,
                  images_upload_url: false,
                  automatic_uploads: false,
                  relative_urls: false,
                  images_reuse_filename: true
                }"
                api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
              />
            </a-col>
          </a-row>

          <!-- answer -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Ответ:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <editor
                :key="'tinymce_' + tabPane"
                v-model="form.answer[langTab]"
                :init="{
                  height: 300,
                  plugins: [
                    'advlist preview autolink lists link image imagetools charmap print preview',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                  ],
                  toolbar:
                    'undo redo | preview | formatselect | bold italic underline forecolor | \
                  image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat',
                  language: 'ru',
                  language_url: '/js/tinymce/langs/ru.js',
                  menubar: false,
                  images_upload_url: false,
                  automatic_uploads: false,
                  relative_urls: false,
                  images_reuse_filename: true
                }"
                api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
              />
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"
export default {
  components: {
    editor: Editor
  },
  data: () => ({
    langTab: $langPrefix,
    tabPane: "content",
    pending: false,
    loading: false,
    form: {
      question: {
        uz: "",
        oz: "",
        ru: "",
        en: ""
      },
      answer: {
        uz: "",
        oz: "",
        ru: "",
        en: ""
      },
      position: 1
    }
  }),
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      if (!this.$route.params.id) {
        console.log("No id on route params")
        return
      }
      this.loading = true
      try {
        const r = await this.$store.dispatch(
          "faq/detail",
          this.$route.params.id
        )

        // console.log(r);
        if (r) {
          this.$set(this, "form", {
            ...r,
            question: {
              ...this.langKeys,
              ...(r.question && JSON.parse(r.question))
            },
            answer: {
              ...this.langKeys,
              ...(r.answer && JSON.parse(r.answer))
            }
          })
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }

      this.loading = false
    },
    tabPaneChangeHandler(arg) {
      this.tabPane = arg
    },

    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab == "uz" ? "oz" : "uz",
          methodName = this.langTab == "uz" ? "toKirill" : "toLatin"

        if (this.form.question[from]) {
          this.form.question[to] = this[methodName](this.form.question[from])
        }

        if (this.form.answer[from]) {
          this.form.answer[to] = this[methodName](this.form.answer[from])
        }
      } catch (error) {
        console.log("translitAction error", error)
      }
    },

    async submit() {
      this.pending = true
      try {
        const req = {
          method: this.form.id ? "update" : "create",
          id: this.form.id || null,
          data: {
            ...this.form,
            question: this.form.question && JSON.stringify(this.form.question),
            answer: this.form.answer && JSON.stringify(this.form.answer)
          }
        }

        const r = await this.$store.dispatch(`faq/${req.method}ItemAction`, {
          id: req.id,
          data: req.data
        })

        // console.log(r);

        if (r && r.id) {
          this.$message.success("Данные сохранены")
          this.$router.push({ name: "faq" })
        }
      } catch (e) {
        console.log(e)
        this.pending = false
      }

      this.pending = false
    }
  }
}
</script>
